import { render, staticRenderFns } from "./OxygenControl.vue?vue&type=template&id=af5e6606&"
import script from "./OxygenControl.vue?vue&type=script&lang=ts&"
export * from "./OxygenControl.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenControl.vue?vue&type=style&index=0&id=af5e6606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports